import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { KeycloakService } from "@inoventoryapps/keycloak-angular";
import { LOCALSTORAGEKEYS } from "../_constants/localStorageKeys";
import { LocalService } from "../_services/_storage/local.service";
import { IndexedStorageService } from "../_services/_storage/indexed-db-service.service";
import { UserService } from "../_services/_user/user.service";
import { SnackbarService } from "../_services/snackbar/snackbar.service";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private keycloakService: KeycloakService,
    private localService: LocalService,
    private userService: UserService,
    public indexStorage: IndexedStorageService,
    private router: Router,
    private snack: SnackbarService,
  ) {}

  isLoggedIn(): boolean {
    if (environment.authMode === "mock") {
      return !!this.localService.get("mockUser");
    }
    try {
      return this.keycloakService.isLoggedIn();
    } catch {
      return false;
    }
  }

  getLoggedinUser() {
    if (environment.authMode === "mock") {
      return this.localService.get("mockUser");
    }
    return this.keycloakService.getToken();
  }

  getUserGUID() {
    if (environment.authMode === "mock") {
      return "mock-user-guid";
    }
    return this.keycloakService.getKeycloakInstance().tokenParsed?.sub || "";
  }

  getAccessToken() {
    if (environment.authMode === "mock") {
      return null;
    }
    return this.keycloakService.getKeycloakInstance().idTokenParsed;
  }

  getRoles() {
    return this.localService.get(LOCALSTORAGEKEYS.USERROLES);
  }

  async login(): Promise<void> {
    if (environment.authMode === "mock") {
      this.localService.set("mockUser", {
        name: "Demo User",
        email: "demo@lokos.in",
        roles: ["all"],
      });
      this.localService.set(LOCALSTORAGEKEYS.USERROLES, ["all"]);
      this.router.navigateByUrl("/main/inputs/profiles");
      return;
    }
    await this.keycloakService.login({
      redirectUri: window.location.origin + "/main/inputs/profiles",
    });
  }

  logout() {
    if (environment.authMode === "mock") {
      this.localService.remove("mockUser");
      this.localService.remove(LOCALSTORAGEKEYS.USERROLES);
      this.localService.clearStorage();
      this.router.navigateByUrl("/");
      return;
    }
    this.keycloakService.logout(window.location.origin).then(() => {
      this.snack.successSnackbar("Logged Out Successfully");
    });
    localStorage.clear();
    this.localService.clearStorage();
    sessionStorage.clear();
    this.clearCache();
    this.indexStorage.deleteIndexStorage().then(() => undefined);
  }

  clearCache() {
    this.localService.clearStorage();
    localStorage.clear();
    sessionStorage.clear();
  }
}
